import {
  WORK_MANAGEMENT_MINI_SITE_LINK,
  CRM_MINI_SITE_LINK,
  SOFTWARE_MINI_SITE_LINK,
  WORKFORMS_HOMEPAGE_LINK,
  CANVAS_HOMEPAGE_LINK
} from "constants/links";

export const MAIN_PRODUCTS = [
  {
    name: "Work Management",
    iconLink:
      "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/Generator_featured images/Home Page - 2023/Multi products/Global-zoom/Group_1261162132.png",
    miniSiteLink: WORK_MANAGEMENT_MINI_SITE_LINK
  },
  {
    name: "Sales CRM",
    iconLink:
      "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/Generator_featured images/Home Page - 2023/Multi products/Global-zoom/Group_1261162055.png",
    miniSiteLink: CRM_MINI_SITE_LINK
  },
  {
    name: "Dev",
    iconLink:
      "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/Generator_featured images/Home Page - 2023/Multi products/Global-zoom/Group_1261160637.png",
    miniSiteLink: SOFTWARE_MINI_SITE_LINK
  }
];

export const ADDITIONAL_PRODUCTS = [
  {
    name: "WorkForms",
    iconLink:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/footer/workforms_icon_footer.png",
    miniSiteLink: WORKFORMS_HOMEPAGE_LINK
  },
  {
    name: "WorkCanvas",
    iconLink:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/footer/workcanvas_icon_footer.png",
    miniSiteLink: CANVAS_HOMEPAGE_LINK
  }
];
